import { Injectable } from '@angular/core';
import { Firestore, collection, query, where, getDocs } from '@angular/fire/firestore';
import { Observable, from } from 'rxjs';
import { map, catchError, tap } from 'rxjs/operators';
import { IBasicUser, IUser } from '../../../shared/models/users/user.model';
import { UserTypes } from '../../../shared/models/users/constants/user-types';

@Injectable({
    providedIn: 'root'
})
export class CustomerCountService {


    private readonly collectionName = 'users';

    constructor(private firestore: Firestore) { }

 getCustomerCount(): Observable<number> {
    const clientsCollection = collection(this.firestore, 'clients');

    return from(getDocs(clientsCollection)).pipe(
        map(snapshot => snapshot.size)
    );
}


}
